<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <need-assistant @click="onClickAssistant($event)" />
      </v-dialog>
    <div v-if="loadData">
      <v-layout class="mt-1">
        <v-flex xs10 sm10 lg10 md10 offset-lg1 offset-md1 offset-sm1>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card>
              <v-card-title class="project">
                <div>
                  <span class="headline white--text"
                    >{{ formTitle }}</span
                  >
                </div>
                <div class="red--text headline ml-2">
                  <v-btn
                    color="white darken-1"
                    small
                    dark
                    class="no-upercase red--text"
                    @click="needAssistant"
                  >
                    Need assistance
                  </v-btn>
                </div>
              </v-card-title>
              <v-card-text>
                <v-layout
                  row
                  v-for="(element, index) in editedItem.assignAgentMemberInfo"
                  :key="index"
                >
                  <v-flex xs12 sm2 md2>
                    <v-text-field
                      v-model="editedItem.assignAgentMemberInfo[index].dasher_id"
                      box
                      label="Agent ID"
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3 md3>
                    <v-text-field
                      v-model="editedItem.assignAgentMemberInfo[index].name"
                      box
                      label="name"
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3 md3>
                    <v-text-field
                      v-model="
                        editedItem.assignAgentMemberInfo[index].agent_group_id
                      "
                      box
                      label="Agent Group ID"
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-text-field
                      numeric
                      v-model="
                        editedItem.assignAgentMemberInfo[index]
                          .number_of_allowed_task
                      "
                      box
                      label="Number of Allowed Task"
                      :rules="allowedTaskRules"
                      @keypress="isDigit($event)"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <button class="button" flat @click="back">Back</button>
                <v-spacer></v-spacer>
                <v-btn class="button" flat @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import router from "@/router";
import { NeedAssistant } from "@/components/index";

export default {
  components: {
    NeedAssistant,
  },
  data: () => ({
    valid: true,
    dialog: false,
    search: "",
    snackbar: false,
    y: "top",
    x: "right",
    timeout: 4000,
    apiUrl: "agent.group-members-info",
    editedIndex: -1,
    previousData: [],
    editedItem: {
      project_id:null,
      assignAgentMemberInfo: [],
    },
    defaultItem: {
      project_id:null,
      assignAgentMemberInfo: [],
    },
    allowedTaskRules: [(v) => !!v || "This field is required"],
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    formTitle() {
      return this.editedIndex === -1
        ? "Assign Task Limit To Agents"
        : "Edit Url To Role";
    },
    loadData() {
      if (this.indexData) {
        return this.getSelected();
      } else {
        return false;
      }
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.editedItem.project_id=project_id;
      this.$store.dispatch("indexData", [this.apiUrl, project_id]);
    },
    getSelected() {
      this.editedItem.assignAgentMemberInfo = this.indexData.agentGroupMemberInfo;
      return true;
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    editItem(item) {
      this.editedIndex = this.indexData.urlToRoles.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    isDigit(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[0-9]+$/.test(char)) return false;
      // Match with regex
      else {
        this.digitValidate = true;
        e.preventDefault();
      } // If not match, don't add to input text
    },

    deleteItem(item) {
      const index = this.indexData.urlToRoles.indexOf(item);
      var result =
        confirm("Are you sure you want to delete this item?") &&
        this.indexData.urlToRoles.splice(index, 1);
      if (result) {
        this.$store.dispatch("delete", [this.apiUrl, item.id]);
        this.initialize();
      }
    },
    back() {
      localStorage.setItem("EditBudgetObject", JSON.stringify(this.budget));

      router.push("/dynamic-question");
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    needAssistant() {
      this.dialog = true;
      // this.snackbar = true;
      // this.close();
    },
    onClickAssistant(event) {
      if (event == 1) {
        this.dialog = false;
        this.snackbar = true;
        this.close;
      } else {
        this.dialog = false;
      }
    },

    save() {
      if (this.$refs.form.validate()) {
        // console.log(this.editedItem);
        this.$store.dispatch("storeOrUpdateProjectAgentTaskDefine", [
          "define.project.task.to-agent",
          this.editedItem,
        ]);
        this.snackbar = true;
        this.close();
      }
    },
  },
};
</script>
<style scoped>
.tbl-border {
  border: 1px solid #000;
}
.table-th {
  border: 1px solid #000;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
.no-upercase {
  text-transform: unset !important;
}
</style>
